<div class="outer-container">
  <!-- Presets -->
  <mode-labeled-menu
    data-test="preset-menu"
    class="preset-menu"
    label="Presets"
    menuClass="currency-format-pane-menu"
    [selected]="selectedPreset"
    [menuItems]="Presets"
    (menuChange)="onPresetSelected($event)"
  ></mode-labeled-menu>
  <ng-container *ngIf="isCustomPreset">
    <!-- Currency prefix-->
    <mode-labeled-menu
      data-test="currency-prefix-menu"
      class="prefix-menu"
      label="Custom prefix"
      menuClass="currency-format-pane-menu"
      [selected]="selectedPrefixSymbol"
      [menuItems]="CurrencySymbols"
      (menuChange)="onPrefixSelected($event)"
    ></mode-labeled-menu>
    <!-- Custom prefix -->
    <ng-container *ngIf="selectedPrefixSymbol?.value === 'custom'; then customPrefixInput; else empty"></ng-container>
    <ng-template #customPrefixInput>
      <input
        data-test="custom-prefix-input"
        type="text"
        class="form-control form-control-sm prefix-input"
        step="any"
        placeholder="Enter a custom symbol..."
        [ngModel]="format.currencySymbolPrefix"
        (ngModelChange)="onCurrencyPrefixChange($event)"
      />
    </ng-template>
    <!-- Currency suffix-->
    <mode-labeled-menu
      data-test="custom-currency-suffix-menu"
      class="suffix-menu"
      label="Custom suffix"
      menuClass="currency-format-pane-menu"
      [selected]="selectedSuffixSymbol"
      [menuItems]="CurrencySymbols"
      (menuChange)="onSuffixSelected($event)"
    ></mode-labeled-menu>
    <ng-container *ngIf="selectedSuffixSymbol?.value === 'custom'; then customSuffixInput; else empty"></ng-container>
    <ng-template #customSuffixInput>
      <input
        data-test="custom-suffix-input"
        type="text"
        class="form-control form-control-sm suffix-input"
        step="any"
        placeholder="Enter a custom symbol..."
        [ngModel]="format.currencySymbolSuffix"
        (ngModelChange)="onCurrencySuffixChange($event)"
      />
    </ng-template>
    <div class="divider"></div>
  </ng-container>
  <!-- Empty grid cell placeholder-->
  <ng-template #empty><div></div></ng-template>
  <!-- Display Unit -->
  <mode-labeled-menu
    data-test="display-unit-menu"
    class="display-unit-menu"
    label="Display unit"
    menuClass="currency-format-pane-menu"
    [selected]="selectedDisplayUnit"
    [menuItems]="DisplayUnits"
    (menuChange)="onDisplayUnitSelected($event)"
  ></mode-labeled-menu>
  <ng-container *ngIf="isCustomPreset">
    <!-- Thousands separator -->
    <mode-labeled-menu
      data-test="thousands-separator-menu"
      class="thousands-separator-menu"
      label="Thousands separator"
      menuClass="currency-format-pane-menu"
      [selected]="selectedThousandsSeparator"
      [menuItems]="ThousandsSeparators"
      (menuChange)="onThousandsSeparatorSelected($event)"
    ></mode-labeled-menu>
    <!-- Thousands grouping -->
    <mode-labeled-menu
      data-test="thousands-grouping-menu"
      class="thousands-grouping-menu"
      label="Thousands grouping"
      menuClass="currency-format-pane-menu"
      [selected]="selectedThousandsGrouping"
      [menuItems]="ThousandsGroupings"
      (menuChange)="onThousandsGroupingSelected($event)"
    ></mode-labeled-menu>
  </ng-container>
  <!-- Decimal separator -->
  <mode-labeled-menu
    data-test="decimal-separator-menu"
    class="decimal-separator-menu"
    label="Decimal separator"
    menuClass="currency-format-pane-menu"
    [selected]="selectedDecimalSeparator"
    [menuItems]="DecimalSeparators"
    (menuChange)="onDecimalSeparatorSelected($event)"
  ></mode-labeled-menu>
  <!-- Decimal precision -->
  <div class="precision-container">
    <label class="form-control-label">Decimal places</label>
    <input
      data-test="currency-format-decimals-input"
      type="number"
      class="form-control form-control-sm"
      step="1"
      min="0"
      max="12"
      placeholder="Auto"
      [ngModel]="format.precision"
      (ngModelChange)="onPrecisionChange($event)"
    />
    <div class="subtext">Between 0-12</div>
  </div>
  <!-- Negative behavior -->
  <mode-labeled-menu
    data-test="negative-behavior-menu"
    class="negative-behavior-menu"
    label="Negative currency style"
    menuClass="currency-format-pane-menu"
    [selected]="selectedNegativeBehavior"
    [menuItems]="NegativeBehavior"
    (menuChange)="onNegativeBehaviorSelected($event)"
  ></mode-labeled-menu>
</div>
